import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "../lib/api";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import About from "../components/landing/About";
import Services from "../components/landing/Services";
import Experience from "../components/landing/Experience";
import Team from "../components/landing/Team";
import Clients from "../components/landing/Clients";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import Logo from "../components/Logo";

export default function Landing() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-jauja-bg">
        <Logo height={64} className="animate-pulse" />
      </div>
    );
  }

  return (
    <div className="jauja-landing min-h-screen font-sans antialiased" data-testid="landing-page">
      <Nav />
      <main>
        <Hero hero={content.hero} />
        <About about={content.about} />
        <Services services={content.services} />
        <Experience experience={content.experience} />
        <Team team={content.team} />
        <Clients clients={content.clients} />
        <Contact contact={content.contact} />
      </main>
      <Footer contact={content.contact} />
    </div>
  );
}
